<side-panel-header [title]="'Approvals' | translate" />
<side-panel-content>
  <sb-tab-group [(selectedIndex)]="selectedTab" [noPadding]="true">
    @if (canSeeSupervisorRequests()) {
      <sb-tab [title]="'Requests' | translate">
        <supervisor-requests-content />
      </sb-tab>
    }
    <sb-tab [title]="'My requests' | translate">
      <my-requests-content />
    </sb-tab>
  </sb-tab-group>
</side-panel-content>
